import { render } from "./InspirationAndTributes.vue?vue&type=template&id=67732f31"
import script from "./InspirationAndTributes.vue?vue&type=script&lang=ts"
export * from "./InspirationAndTributes.vue?vue&type=script&lang=ts"
script.render = render

export default script